import React, { useState, useEffect } from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { formatDateForBlog as formatDate } from '~/helpers/data';
import fetchRexRelease from '~/models/rex-release';
import { FormattedMessage, useIntl } from 'react-intl';
import useDetailsContext from '../context';
function PdfUpdateInfo({ updateDate, url }) {
    if (!updateDate) {
        return null;
    }
    return (React.createElement("div", { className: "loc-pdf-update-date" },
        React.createElement("div", { className: "callout-container" },
            React.createElement("h4", null,
                React.createElement(FormattedMessage, { id: "pubinfo.pdf.heading", defaultMessage: "PDF Version Last Updated:" })),
            formatDate(updateDate),
            url && (React.createElement("div", { className: "callout" },
                React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "pubinfo.pdf.see", defaultMessage: "See changes in the" }),
                    ' ',
                    React.createElement("a", { href: url },
                        React.createElement(FormattedMessage, { id: "pubinfo.pdf.notes", defaultMessage: "Revision Notes" })),
                    "."))))));
}
function IsbnInfo({ label, tag }) {
    const model = useDetailsContext();
    const entries = ['10', '13']
        .map((number) => {
        const value = model[`${tag}Isbn${number}`];
        return {
            number,
            value
        };
    })
        .filter((entry) => entry.value);
    if (entries.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `loc-${tag}-isbn` },
            React.createElement("h4", null, `${label}:`),
            entries.map(({ number, value }) => (React.createElement("div", { key: value }, `ISBN-${number}: ${value}`))))));
}
function LicenseIcon({ name }) {
    const icon = name.match(/share/i)
        ? '/dist/images/details/by-nc-sa.svg'
        : '/dist/images/details/by.svg';
    return React.createElement("img", { src: icon, alt: "", height: "42", width: "120" });
}
function LicenseInfo({ name, text, title, version }) {
    if (!name) {
        return null;
    }
    return (React.createElement("div", { className: "loc-license" },
        React.createElement("h4", null,
            React.createElement(FormattedMessage, { id: "pubInfo.license.heading", defaultMessage: "License" }),
            ":"),
        React.createElement(LicenseIcon, { name: name }),
        React.createElement("div", null, text ? (React.createElement(RawHTML, { html: text })) : (React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "pubInfo.license", values: { title, name, version } }))))));
}
function PolishIsbn({ format, header, model }) {
    const n10 = model[`${format}Isbn10`];
    const n13 = model[`${format}Isbn13`];
    if (!(n10 || n13)) {
        return null;
    }
    return (React.createElement("div", { className: `loc-${format}-isbn` },
        React.createElement("h4", null, header),
        n10 && React.createElement("div", null,
            "ISBN-10: ",
            n10),
        n13 && React.createElement("div", null,
            "ISBN-13: ",
            n13)));
}
function PolishLicense({ model }) {
    if (!model.licenseName) {
        return null;
    }
    return (React.createElement("div", { className: "loc-license" },
        React.createElement("h4", null, "Licencja:"),
        React.createElement(LicenseIcon, { name: model.licenseName }),
        React.createElement("img", { src: model.licenseIcon, alt: "" }),
        React.createElement("div", null, model.licenseText ? (React.createElement(RawHTML, { html: model.licenseText })) : (React.createElement("div", null,
            React.createElement(RawHTML, { Tag: "span", html: model.title }),
            "by OpenStax jest licencjonowana na licencji",
            React.createElement("span", { className: "text" },
                model.licenseName,
                " v",
                model.licenseVersion))))));
}
function PolishPublicationInfo() {
    const model = useDetailsContext();
    return (React.createElement("div", { className: "publication-info" },
        model.publishDate ? (React.createElement("div", { className: "loc-pub-date" },
            React.createElement("h4", null, "Data publikacji:"),
            formatDate(model.publishDate))) : null,
        React.createElement(PolishIsbn, { header: "Wydrukowane:", model: model, format: "print" }),
        React.createElement(PolishIsbn, { header: "Wersja cyfrowa:", model: model, format: "digital" }),
        React.createElement(PolishLicense, { model: model })));
}
function LabeledDate({ label, date, className }) {
    if (!date) {
        return null;
    }
    return (React.createElement("div", { className: className },
        React.createElement("h4", null, label),
        formatDate(date)));
}
export default function PublicationInfo({ url, polish }) {
    const model = useDetailsContext();
    const [webUpdate, setWebUpdate] = useState(model.lastUpdatedWeb);
    const intl = useIntl();
    const [pub, web, hard, paper, dig, assignable] = [
        intl.formatMessage({ id: 'pubInfo.pub.pub' }),
        intl.formatMessage({ id: 'pubInfo.pub.web' }),
        intl.formatMessage({ id: 'pubInfo.pub.color' }),
        intl.formatMessage({ id: 'pubInfo.pub.b-w' }),
        intl.formatMessage({ id: 'pubInfo.pub.dig' }),
        intl.formatMessage({ id: 'pubInfo.pub.assignable' })
    ];
    useEffect(() => {
        const isRex = Boolean(model.webviewRexLink);
        if (isRex) {
            fetchRexRelease(model.webviewRexLink, model.cnxId).then(({ revised }) => setWebUpdate(revised), (err) => console.warn('Error fetching Rex info:', err));
        }
    }, [model]);
    if (polish) {
        return React.createElement(PolishPublicationInfo, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(LabeledDate, { label: pub, className: "loc-pub-date", date: model.publishDate }),
        React.createElement(LabeledDate, { label: web, className: "loc-web-update-date", date: webUpdate }),
        React.createElement(PdfUpdateInfo, { updateDate: model.lastUpdatedPdf, url: url }),
        React.createElement(IsbnInfo, { label: hard, tag: "print" }),
        React.createElement(IsbnInfo, { label: paper, tag: "printSoftcover" }),
        React.createElement(IsbnInfo, { label: dig, tag: "digital" }),
        React.createElement(IsbnInfo, { label: assignable, tag: "assignable" }),
        React.createElement(LicenseInfo, { name: model.licenseName, text: model.licenseText, title: model.licenseTitle, version: model.licenseVersion })));
}
